import React, { useEffect } from "react";

import HeaderMenu from "../../component/Navbar/headermenu";
import CustomFooter from "../../component/Footer/customFooter";
const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = "Privacy Policy - Simplifyte";
  }, []);


  return (
    <>
      <HeaderMenu />
      <div
        className="p-4 md:p-8 max-w-4xl mx-auto text-gray-800"
        style={{ textAlign: "justify" }}
      >
        <h1
          className="font-size-same text-2xl font-bold mb-4"
          style={{ marginTop: "108px" }}
        >
          Privacy Policy
        </h1>

        <section className="mb-6 PrivacyPolicy">
          <p>
            This Privacy Policy explains how Simplifyte Labs Private Limited
            (referred to as “Simplifyte,” “we,” “us,” or “our”) collects, uses,
            discloses, and protects information about you when you use our
            cloud-based digital workflow platform and related services
            (collectively, the Service). We are committed to safeguarding your
            privacy and complying with applicable data protection laws.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-bold mb-4">Information We Collect</h2>
          <p className="mb-4">
            We collect information that you provide directly to us and
            information automatically collected when you use our Service,
            including:
          </p>
          <ul className="policy-list list-disc ml-6 space-y-2">
            <li>
              <strong>Registration and Profile Information:</strong> When you
              sign up for the Service or update your profile, we collect
              personal information such as your name, email address, company
              name, job title, phone number, and other contact details.
            </li>
            <li>
              <strong>Account Credentials:</strong> We store and use your
              account credentials
              {/* (username and encrypted password) */}
              to authenticate you. We do not have access to your plaintext
              password.
            </li>
            <li>
              <strong>Payment and Billing Information:</strong> When you
              subscribe to a paid plan, we collect billing details such as
              billing address and company information. We use a secure
              third-party payment gateway
              {/* (e.g., Razorpay) */}
              to process payments and do not store your credit card or payment
              card details on our servers.
            </li>
            <li>
              <strong>Usage and Technical Data:</strong> We automatically
              collect data about how you access and use the Service, including
              IP address, device and browser information, operating system,
              referring URLs, pages visited, and other log data. We also collect
              performance data and diagnostics information to help us improve
              the Service.
            </li>
            <li>
              <strong>User Content and Documents:</strong> The Service allows
              you to create, upload, or store content (such as documents,
              images, notes, and other data) within the platform. Any content
              you upload is considered “User Content” and remains your property.
              We process your User Content only to provide the Service
              {/* (for
              example, to display or transmit it as part of the Service). */}
            </li>
            <li>
              <strong>Communications:</strong> If you contact us{" "}
              {/* (for example, for support), */}
              we collect the information you provide to us, such as your email
              address, name, and the content of your message.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-bold mb-4">How We Use Information</h2>
          <p className="mb-4">
            We use the collected information for the following purposes:
          </p>
          <ul className="policy-list list-disc ml-6 space-y-2">
            <li>
              <strong>Provide and Improve the Service:</strong> {""}
              To deliver, operate, and maintain the Service (including account
              setup, authentication, and billing), we analyze usage patterns to
              improve functionality and user experience.
              {/* To deliver,
              operate, and maintain the Service (including account setup,
              authentication, and billing). We analyze usage patterns to improve
              functionality and user experience. */}
            </li>
            <li>
              <strong>Account Management:</strong> To manage your account,
              process transactions, send invoices, and handle subscription
              renewals.
            </li>
            <li>
              <strong>Communications:</strong> To send you service-related
              announcements, updates, and support messages. We may also send
              marketing emails about new features or promotions (you can opt out
              of marketing communications at any time).
            </li>
            <li>
              <strong>Personalization:</strong> To personalize your experience
              (for example, by providing relevant support and recommendations).
            </li>
            <li>
              <strong>Security and Fraud Prevention:</strong> To verify
              identities, prevent and investigate fraud or abuse, and protect
              the security of our Service and systems.
            </li>
            <li>
              <strong>Legal Compliance:</strong> To comply with legal
              obligations, enforce our Terms of Service, and protect our rights
              as well as the rights of others.
              {/* To comply with legal
              obligations, enforce our Terms of Service, and protect our rights
              and the rights of others. */}
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-bold mb-4">Sharing of Information</h2>
          <p className="mb-4">
            We do not sell your personal information. We may share your
            information in the following ways:
          </p>
          <ul className="policy-list list-disc ml-6 space-y-2">
            <li>
              <strong>Service Providers:</strong> We engage trusted third-party
              vendors to provide and improve the Service. These include cloud
              hosting providers (for data storage and servers), payment
              processors (for subscription billing), email and messaging
              providers (for notifications and support), and analytics providers
              (for usage analysis). These third parties have access to your
              information only to perform their services and are obligated to
              safeguard your data.
            </li>
            <li>
              <strong>Legal and Compliance:</strong> We may disclose information
              if required by law, such as to comply with a subpoena or similar
              legal process, or when we believe in good faith that disclosure is
              necessary to protect our rights, your safety, or the safety of
              others.
            </li>
            <li>
              <strong>Business Transfers:</strong> If Simplifyte undergoes a
              merger, acquisition, or sale of assets, your information may be
              transferred as one of the business assets. We will ensure such
              parties honor the commitments mentioned in this Privacy Policy.
              {/* If Simplifyte undergoes a
              merger, acquisition, or sale of assets, your information may be
              transferred as one of the business assets. We will ensure such
              parties honor the commitments we have made in this Privacy Policy. */}
            </li>
            <li>
              <strong>Aggregated or De-identified Data:</strong> We may share
              aggregated or de-identified information that does not identify you
              or any individual, for analytics or research purposes.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-bold mb-4">Cookies and Tracking</h2>
          <p className="mb-4">
            We use cookies and similar tracking technologies to enhance your
            experience and gather usage information. “Cookies” are small data
            files stored on your device when you visit our website or use the
            Service. We may use:
          </p>
          <ul className="policy-list list-disc ml-6 space-y-2">
            <li>
              <strong>Essential Cookies:</strong> Necessary for the operation of
              the Service, such as maintaining your login session and providing
              secure access.
            </li>
            <li>
              <strong>Performance and Analytics Cookies:</strong> To collect
              information about how the Service is used (for example, pages
              visited and time spent) so we can improve performance and
              features.
            </li>
            <li>
              <strong>Functionality cookies:</strong> To remember your
              preferences (such as language or display settings) across visits.
            </li>
            <li>
              <strong>Advertising and Marketing Cookies:</strong> We do not use
              advertising or marketing cookies at this time.
            </li>
          </ul>
          <p className="mt-4 mb-4">
            Third-party services (e.g., analytics or social media tools) may
            also set cookies when you use our Service. We do not control these
            third-party cookies; they are governed by the third party’s own
            policies.
          </p>
          <p className="mb-4">
            You can control or delete cookies through your browser settings.
            However, disabling cookies may affect the functionality of our
            Service. For more details on cookies and how to manage them, please
            see our Cookie Policy.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-bold mb-4">
            Data Storage and International Transfers
          </h2>
          <p className="mb-4">
            {/* Your data is stored on secure servers located in India through our
            cloud hosting providers. We take reasonable steps to ensure your
            information is stored securely. In some cases, data (including
            backups or analytics data) may be accessed from servers in other
            countries. When personal data is transferred outside India, we will
            ensure that appropriate safeguards are in place (for example,
            Standard Contractual Clauses) in compliance with applicable laws. */}
            Your data is stored on secure servers located in India through our
            cloud hosting providers. We take reasonable steps to ensure that
            your information is stored securely. In some cases, data (including
            backups or analytics data) may be accessed from servers in other
            countries. When personal data is transferred outside India, we will
            ensure that appropriate safeguards are in place (for example,
            Standard Contractual Clauses) in compliance with applicable laws.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-bold mb-2">Data Retention</h2>
          <p className="mb-4">
            We retain personal information for as long as necessary to provide
            the Service and fulfill the purposes described in this Policy,
            unless a longer retention period is required or permitted by law.
            For example, we may retain billing and transactional data for
            financial recordkeeping. When data is no longer needed, we will
            delete or anonymize it.
            {/* We retain personal information for as long as necessary to provide
            the Service and fulfill the purposes described in this Privacy
            Policy, unless a longer retention period is required or permitted by
            law. For example, we may retain billing and transactional data for
            financial recordkeeping. When data is no longer needed, we will
            securely delete or anonymize it. */}
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-bold mb-2">Your Rights and Choices</h2>
          <p className="mb-4">
            {/* Depending on your jurisdiction, you may have certain rights
            regarding your personal information, including the right to access,
            correct, update, or delete your data. You can update your account
            information directly in your profile. To request access, correction,
            or deletion of personal data, or to object to certain processing,
            please contact us at the address below. We will respond to your
            request in accordance with applicable law. */}
            Depending on your jurisdiction, you may have certain rights
            regarding your personal information, including the right to access,
            correct, update, or delete your data. You can update your account
            information directly in your profile. To request access, correction,
            or deletion of personal data, or to object to certain processing,
            please contact us at the address below. We will respond promply in
            accordance with the applicable law.
          </p>
          <p className="mb-4">
            {/* You may also unsubscribe from marketing communications at any time
            by following the instructions in the email or by contacting us.
            Please note that transactional or service-related communications
            (such as security alerts or account statements) are not optional. */}
            You may also unsubscribe from marketing communications at any time
            by following the instructions in the email or by contacting us.
            Please note that transactional or service-related communications
            (such as security alerts or account statements) are not optional.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-bold mb-2">Security</h2>
          <p className="mb-4">
            We implement industry-standard technical, administrative, and
            physical safeguards to protect your personal information. For
            example, we use encryption (TLS) for data in transit and encryption
            at rest for stored data. Access to personal data is limited to
            authorized personnel on a need-to-know basis. However, no system can
            be completely secure, and we cannot guarantee absolute security of
            your data.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-bold mb-2">Children’s Privacy</h2>
          <p className="mb-4">
            {/* The Service is not intended for children under the age of 13. We do
            not knowingly collect personal information from children. If we
            become aware that we have inadvertently received personal data from
            a child, we will take steps to delete that information. */}
            The Service is not intended for children under the age of 13. We do
            not knowingly collect personal information from children. If we
            become aware that we have inadvertently received personal data from
            a child, we will take steps to remove that information.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-bold mb-2">
            Changes to This Privacy Policy
          </h2>
          <p className="mb-4">
            We may update this Privacy Policy from time to time (for example,
            when we introduce new services or features). When we make changes,
            we will update the <strong>Last updated</strong> date above and
            notify you by posting the new policy on this page. You should review
            this page periodically to stay informed of our current practices.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-2">Contact Information</h2>
          <p className="mb-4">
            If you have any questions or concerns about this Privacy Policy or
            our data practices, please contact us:
          </p>
          <p>
            Simplifyte Labs Private Limited
            <br />
            5th Floor, Meghani Luxe, Meghani Circle
            <br />
            Bhavnagar-364001, Gujarat, India
            <br />
            Email:{" "}
            <a
              href="mailto:support@simplifyte.com"
              className="text-blue-600 underline"
            >
              support@simplifyte.com
            </a>
          </p>
        </section>
      </div>
      <CustomFooter />
    </>
  );
};

export default PrivacyPolicy;
